"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BDSInputColorPicker = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("react");
var react_color_1 = require("react-color");
var BDSInputColorPicker_style_1 = require("./BDSInputColorPicker.style");
var ValidColorRGBRegex = new RegExp(/^#[0-9a-fA-F]+/);
var BDSInputColorPicker = function (props) {
    var outside = react_1.useRef(null);
    var _a = react_1.useState(false), colorPickerOpened = _a[0], setColorPickerOpened = _a[1];
    var _b = react_1.useState(false), colorPickerBlurred = _b[0], setColorPickerBlurred = _b[1];
    var updateColor = function (event) {
        var inputValue = event.target.value;
        var value;
        if (inputValue.match(ValidColorRGBRegex))
            value = inputValue;
        else if (inputValue.length === 0)
            value = '#ffffff';
        else if (!inputValue.match(/^#.*/))
            value = '#ffffff';
        else
            value = inputValue;
        props.handleUpdate(value);
    };
    var blurHandler = function () {
        if (!props.color)
            props.handleUpdate('#ffffff');
        else if (props.color.indexOf('#') !== 0)
            props.handleUpdate('#ffffff');
        else if (props.color.length > 7)
            props.handleUpdate(props.color.slice(0, 7));
        else if (props.color.length < 7)
            props.handleUpdate(props.color.concat('000000').slice(0, 7));
        else if (props.color.match(/([g-z]|[G-Z])/))
            props.handleUpdate(props.color.replace(/([g-z]|[G-Z])/g, '0'));
    };
    function blurPicker(event) {
        if (outside.current !== event.target) {
            setColorPickerBlurred(true);
        }
        document.removeEventListener('mousedown', blurPicker);
    }
    react_1.useEffect(function () {
        if (colorPickerOpened && colorPickerBlurred) {
            setColorPickerOpened(false);
            setColorPickerBlurred(false);
        }
    }, [colorPickerBlurred]);
    return (jsx_runtime_1.jsxs("div", tslib_1.__assign({ css: [BDSInputColorPicker_style_1.inputColorPickerCss], className: "input-color-picker " + (colorPickerOpened ? 'relative' : '') + " " }, { children: [colorPickerOpened ? (jsx_runtime_1.jsx("div", tslib_1.__assign({ ref: outside, className: "color-picker-wrapper", onMouseLeave: function () {
                    document.addEventListener('mousedown', blurPicker);
                } }, { children: jsx_runtime_1.jsx(react_color_1.SketchPicker, { color: props.color, onChange: function (color) {
                        props.handleUpdate(color.hex);
                    } }, void 0) }), void 0)) : (jsx_runtime_1.jsx("div", { onClick: function () {
                    setColorPickerOpened(true);
                }, className: "material-button-color", style: {
                    backgroundColor: props.color,
                } }, void 0)),
            jsx_runtime_1.jsx("input", { value: props.color, onChange: updateColor, onBlur: function () {
                    blurHandler();
                }, maxLength: 7, pattern: "[0-9a-fA-F]" }, void 0)] }), void 0));
};
exports.BDSInputColorPicker = BDSInputColorPicker;
